import React from 'react';
import TooltipButton from '../../Atoms/buttons/TooltipButton';
import { EditableTimeInput } from '../../Atoms/inputs/EditableTimeInput';
import { TimeFormatter } from '../../Atoms/Formatter/TimeFormatter';
import { EditableEventDateProperty } from '../../Atoms/EditableProperties/EditableEventDateProperty';
import EditableDateInput from '../../Atoms/inputs/EditableDateInput';
import { DateFormatter } from '../../Atoms/Formatter/DateFormatter';
import { ToastS } from '../../Service/ToastS';
import {TestS} from "../../TestS";

export default React.memo(
  ({ dates, style, changeHandler }) => {
    function refreshHandler(dates) {
      changeHandler({ dates });
    }

    const styles = {
      container: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: -10,
        marginBottom: 5,
        flexWrap: 'wrap',
        maxWidth: 338,
      },
      trashComponent: {
        textAlign: 'center',
        marginTop: 10,
      },
      dateComponent: {
        flex: 2,
        marginRight: 12,
        maxWidth: 100,
      },
      timeFromComponent: {
        flex: 1,
        marginRight: 5,
      },
      timeToComponent: {
        flex: 1,
        marginRight: 5,
      },
      addButton: {
        fontSize: 13,
        padding: 0,
      },
    };

    function deleteItem(items, index) {
      if (items.length === 1) {
        ToastS.warn('delete.item', 'Es muss mindestens ein Event-Datum angegeben werden');
      } else {
        items = items.slice(0, index).concat(items.slice(index + 1));
        refreshHandler(items);
      }
    }

    const items = dates;
    return (
      <div style={style}>
        {items.map((val, index) => (
          <div style={styles.container} key={index}>
            <div style={styles.dateComponent}>
              <EditableEventDateProperty
                patchField="date"
                placeholder="event.date"
                editFormatter={EditableDateInput}
                labelFormatter={DateFormatter}
              />
            </div>

            <div style={{ display: 'flex', flex: 1, minWidth: 226 }}>
              <div style={styles.timeFromComponent}>
                <EditableEventDateProperty
                  patchField="timeFrom"
                  placeholder="event.time.from"
                  editFormatter={EditableTimeInput}
                  labelFormatter={TimeFormatter}
                  testId={TestS.Events.Details.DATE_FROM}
                />
              </div>
              <div style={styles.timeToComponent}>
                <EditableEventDateProperty
                  patchField="timeTo"
                  placeholder="bis"
                  editFormatter={EditableTimeInput}
                  labelFormatter={TimeFormatter}
                  testId={TestS.Events.Details.DATE_TO}
                />
              </div>
              <div style={{ width: 38, marginBottom: 10, textAlign: 'center', alignSelf: 'flex-end' }}>
                <div className="description">{val.hours ? `${val.hours} h` : ''}</div>
              </div>
            </div>
            {/* <div  style={styles.trashComponent}>
                            <DeleteAction deletePosition={() => deleteItem(items, index)} index={index} count={items.length} />
                        </div> */}
          </div>
        ))}

        {/* <TransButtonLink style={styles.addButton}
                             text="event.dates.button.add" onClick={addDateTimeItem}/> */}
      </div>
    );
  },
  (prevProps, nextProps) => prevProps.dates === nextProps.dates,
);

export const DeleteAction = (props) => {
  const opts = {};
  /* if (props.count === 1) {
        opts['disabled'] = true;
    } */

  return (
    <TooltipButton
      id={`delete${props.index}`}
      text="actions.document.position.delete"
      {...opts}
      onClick={props.deletePosition}
      icon="TRASH"
    />
  );
};
